export const SESSION_TYPES = {
    LIVE: 'LIVE',
    OFFLINE: 'OFFLINE',
    SCREEN_SHARING: 'SCREEN',
    APPLICATION_SHARING: 'APPLICATION_SHARING',
    CO_BROWSING: 'CO_BROWSING'
};
